import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import HMap from './hmap';

class ShareImg extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
        updateTime: PropTypes.string,
        qrcodeImage: PropTypes.string,
    };

    render() {
        const { data, updateTime, qrcodeImage } = this.props;

        const { bidenNum, trumpNum, status } = data[0];

        let img = 'https://x0.ifengimg.com/ucms/2024_45/E96C10A33F673EC79C23023F9C9E49E7035CF3AE_size117_w750_h1334.jpg';
        // let img = 'https://x0.ifengimg.com/ucms/2020_45/26FA0EC4B3E539D0B279DFA725360B6C75BA5266_w750_h1334.jpg';

        if (status === '已结束') {
            if (bidenNum >= 270) {
                img = 'https://x0.ifengimg.com/ucms/2024_45/3E70444F22D799030A66C4F71B369D2298EC2E17_size121_w750_h1334.jpg';
            }
            if (trumpNum >= 270) {
                img = 'https://x0.ifengimg.com/ucms/2024_45/D2EC4D04D2C02CE489BBD6F9497C935AB5270CF8_size120_w750_h1334.jpg';
            }
        }

        return (
            // <div id="share" className={styles.haibao}>
            <div id="share" className={styles.haibao} style={{ left: '-760px' }}>
                <img crossOrigin="Anonymous" src={img} className={styles.bgimage} />
                <HMap data={data} updateTime={updateTime} />
                <img src={`https:${qrcodeImage}`} className={styles.qrcode} />
            </div>
        );
    }
}

export default errorBoundary(ShareImg);
